<template>
  <div class="wrapper text-sm">
    <div class="flex items-center justify-between mb-8">
      <h1 class="font-bold capitalize">{{ $t('ui.entities.locationSelection.label') }}</h1>
      <Icon
        v-if="accessSelected.dealerships.length > 0"
        type="times"
        class="text-3xl cursor-pointer"
        @click="closeView"
      ></Icon>
    </div>

    <LocationSelector @save="closeView" />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

// stores
import { useAuthStore } from '@/stores/AuthStore.ts'
import { useAccessStore } from '@/stores/AccessStore.ts'
import updateAbility from '@/config/update-ability.js'

// components
import Icon from '@/components/icon/Icon.vue'
import LocationSelector from '@/components/main-menu/LocationSelector.vue'

const router = useRouter()
const authStore = useAuthStore()
const accessStore = useAccessStore()

const { accessSelected } = storeToRefs(accessStore)

onMounted(async () => {
  const response = await authStore.verify()
  if (response.success) {
    updateAbility(router)
  } else {
    authStore.signOut()
  }
})

/** Leaves the selection view, going home unless there is history to return to */
function closeView() {
  // Retain staff land here from elsewhere in the app, so send them back
  if (authStore.details.userType !== 0) {
    router.push('/')
  } else {
    router.back()
  }
}
</script>

<style scoped>
body {
  min-height: 100%;
}

.wrapper {
  padding: 3rem;

  inline-size: 100%;
  margin-inline: auto;
  max-inline-size: 720px;
}
</style>
